import { render } from "./EmergencyAnswerForm.vue?vue&type=template&id=2f9951d8&scoped=true&ts=true"
import script from "./EmergencyAnswerForm.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswerForm.ts?vue&type=script&lang=ts"

import "./EmergencyAnswerForm.scss?vue&type=style&index=0&id=2f9951d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9951d8"]])

export default __exports__